import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ParameterPagination = ({ currentPage, totalPages, limit, onPageChange, onLimitChange, }) => {
    const maxVisiblePages = 5;
    const pages = [];
    if (totalPages <= maxVisiblePages) {
        for (let index = 1; index <= totalPages; index += 1) {
            pages.push(index);
        }
    }
    else {
        pages.push(1);
        if (currentPage > 3) {
            pages.push('...');
        }
        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);
        for (let index = startPage; index <= endPage; index += 1) {
            pages.push(index);
        }
        if (currentPage < totalPages - 2) {
            pages.push('...');
        }
        pages.push(totalPages);
    }
    return (_jsxs("div", { className: "mt-4 flex items-center justify-between", children: [_jsx("select", { value: limit, onChange: (event) => onLimitChange(Number(event.target.value)), className: "rounded border border-gray-300 px-3 py-2 text-sm text-gray-700 focus:border-blue-500 focus:outline-none", children: [10, 20, 50, 100].map((option) => (_jsx("option", { value: option, children: option }, option))) }), _jsxs("div", { className: "flex items-center gap-2", children: [_jsx("button", { type: "button", onClick: () => onPageChange(Math.max(1, currentPage - 1)), className: `rounded px-3 py-2 text-sm ${currentPage === 1
                            ? 'cursor-not-allowed bg-gray-200 text-gray-400'
                            : 'bg-gray-100 text-gray-700 transition hover:bg-gray-200'}`, disabled: currentPage === 1, children: "<" }), pages.map((page, index) => typeof page === 'number' ? (_jsx("button", { type: "button", onClick: () => onPageChange(page), className: `rounded px-3 py-2 text-sm ${currentPage === page
                            ? 'bg-blue-500 text-white'
                            : 'bg-gray-100 text-gray-700 transition hover:bg-gray-200'}`, children: page }, page)) : (_jsx("span", { className: "px-2 text-sm text-gray-400", children: page }, `ellipsis-${index}`))), _jsx("button", { type: "button", onClick: () => onPageChange(Math.min(totalPages, currentPage + 1)), className: `rounded px-3 py-2 text-sm ${currentPage === totalPages
                            ? 'cursor-not-allowed bg-gray-200 text-gray-400'
                            : 'bg-gray-100 text-gray-700 transition hover:bg-gray-200'}`, disabled: currentPage === totalPages, children: ">" })] })] }));
};
export default ParameterPagination;
